import app from '../app.first';
import $ from 'jquery';

app.PersonalDetails = class extends app.Component {
    constructor($this) {
        super($this);
        $(() => this.onDocumentReady($this));
        // [MYC-197] @SABUILD
        // this.$citizenRadios = $('[name="is_citizen"]');
        // this.$citizenship = $('#pd_have_permit');
        this.$id = $('#pd_id_number');
        this.$idError = $('#pd_id_number_error');
        this.$fileUploads = $('[type="file"]');
        this.$permit = $('[name="have_permit"]').parent('.input.radio');
        this.$address = $('#pd_address');
        this.$postal = $('#pd_postal');
    }

    onDocumentReady($this) {
        // [MYC-197] @SABUILD
        // this.$citizenship.parent().hide();

        // this.$citizenRadios.on('change', (e) => {
        //     let isCitizen = parseInt($(e.target).val());
        //     this.$citizenship.prop('required', isCitizen).parent().toggle(!isCitizen);
        //     this.$permit.toggle(!isCitizen).find('input').prop('checked', false);
        //     if (!!isCitizen) {
        //         this.$id.attr('data-validator', 'id_validator');
        //         $('#personal_details_form').foundation('validateInput', this.$id);
        //     } else {
        //         this.$id.removeAttr('data-validator');
        //         $('#personal_details_form').foundation('validateInput', this.$id);
        //         this.$idError.html('');
        //     }
        // }).trigger('change');

        this.$fileUploads.on('change', function() {
            let $this = $(this);
            $this.closest('.file').find('.file-name').html($this.val().split('\\').pop());
        });
        // [MYC-197] @SABUILD
        // $('#pd_disabilities_and_disorders').hide();

        // $('#have-disabilities-1').click(function() {
        //     $('#pd_disabilities_and_disorders').prop('disabled', false);
        //     $('#pd_disabilities_and_disorders').prop('required', true);
        //     $('#pd_disabilities_and_disorders').show();
        // });

        // $('#have-disabilities-0').click(function() {
        //     $('#pd_disabilities_and_disorders').val('');
        //     $('#pd_disabilities_and_disorders').prop('disabled', true);
        //     $('#pd_disabilities_and_disorders').prop('required', false);
        //     $('#pd_disabilities_and_disorders').prop('data-invalid', false);
        //     $('#pd_disabilities_and_disorders').removeClass('is-invalid-input');
        //     $('#pd_disabilities_and_disorders').hide();
        // });

        // $('[name="have_disabilities"]:checked').trigger('click');

        $('#pd_current_salary').parent().append('<span id="pd_current_salary_value"></span>');
        $('#pd_desired_salary').parent().append('<span id="pd_desired_salary_value"></span>');

        $('#pd_current_salary_value').text('C$' + $('#pd_current_salary').val().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        $('#pd_desired_salary_value').text('C$' + $('#pd_desired_salary').val().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));

        $('#pd_current_salary').on('input', function() {
            $('#pd_current_salary_value').text('C$' + $('#pd_current_salary').val().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        });

        $('#pd_desired_salary').on('input', function() {
            $('#pd_desired_salary_value').text('C$' + $('#pd_desired_salary').val().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        });

        //autocomplete
        var input = document.getElementById('pd_address');
            var options = {
            types: ['address'],
            componentRestrictions: {country:'za'}
        };
        var autocomplete = new google.maps.places.Autocomplete(input, options);
        google.maps.event.addListener(autocomplete, 'place_changed', function() {
            var place = autocomplete.getPlace();
            var postal_code = '';
            for (var i = 0; i < place.address_components.length; i++) {
                for (var j = 0; j < place.address_components[i].types.length; j++) {
                    if (place.address_components[i].types[j] == "postal_code") {
                        postal_code = place.address_components[i].long_name;
                    }
                }
            }
            document.getElementById('pd_postal').value = postal_code;
        })

        // [MYC-197] @SABUILD
        // $('#has-permit-1').parent().parent().hide();
        // if ($('#is-citizen-0').is(':checked')) {
        //     let hasPermitInputContainer = $('#has-permit-1').parent().parent();
        //     hasPermitInputContainer.addClass('required');
        //     hasPermitInputContainer.show();
        //     $('#has-permit-0').attr('required', true);
        //     $('#has-permit-1').attr('required', true);
        // }

        // $('#is-citizen-0').click(function () {
        //     let hasPermitInputContainer = $('#has-permit-1').parent().parent();
        //     hasPermitInputContainer.addClass('required');
        //     hasPermitInputContainer.show();
        //     $('#has-permit-0').attr('required', true);
        //     $('#has-permit-1').attr('required', true);
        // });

        // $('#is-citizen-1').click(function () {
        //     let hasPermitInputContainer = $('#has-permit-1').parent().parent();
        //     hasPermitInputContainer.removeClass('required');
        //     hasPermitInputContainer.hide();
        //     $('#has-permit-0').attr('required', false);
        //     $('#has-permit-1').attr('required', false);
        // });

        $('#pd_province').select2({
            minimumResultsForSearch: -1,
            ajax: {
                url: '/ajax/province-for-country',
                dataType: 'json',
                data: function (params) {
                    let query = {
                        countryId: $('#pd_country_id').val(),
                    }

                    return query;
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
            }
        });
        
        $('#pd_country_id').select2().on('change', function() {
            $('#pd_province_id').select2({
                minimumResultsForSearch: -1,
                ajax: {
                    url: '/ajax/province-for-country',
                    dataType: 'json',
                    data: function (params) {
                        console.log('test');
                        let query = {
                            countryId: $('#pd_country_id').val(),
                        }
    
                        return query;
                    },
                    processResults: function (data) {
                        console.log(data);
                        return {
                            results: data
                        };
                    },
                }
            });
        }).trigger('change');

        if (navigator.geolocation) {
            // $('#pd_address').on('change keyup input focusout', function() {
            //     $('#pd_country_id > option').each(function() {
            //         if ($(this).text().toUpperCase() == $('#pd_hidden_country').val().toUpperCase()) {
            //             $(this).parent().select2('val', [$(this).val()]);
            //         }
            //     });
            //     $('#pd_province_id > option').each(function() {
            //         if ($(this).text().toUpperCase() == $('#pd_hidden_province').val().toUpperCase()) {
            //             $(this).parent().select2('val', [$(this).val()]);
            //         }
            //     });
            // });

            navigator.geolocation.getCurrentPosition(function(position) {
                let geocoder = new google.maps.Geocoder;
                geocoder.geocode({'location': {lat: position.coords.latitude, lng: position.coords.longitude}}, function(results, status) {
                    if (status == 'OK') {
                        //$('#pd_address').val(results[0].formatted_address);
                        for (let componentsLoop = 0; componentsLoop < results[0].address_components.length; componentsLoop++) {
                            if (results[0].address_components[componentsLoop].types[0] == 'country') {
                                $('#pd_country_id > option').each(function() {
                                    if ($(this).text().toUpperCase() == results[0].address_components[componentsLoop].long_name.toUpperCase()) {
                                        $(this).parent().select2('val', [$(this).val()]);
                                        // $.ajax({
                                        //     data: { countryId: $('#pd_country_id').val() },
                                        //     url: '../ajax/province-for-country',
                                        //     type: 'GET',
                                        //     dataType: 'json',
                                        //     success: function(response) {
                                        //         $('#pd_province_id').select2('val', '');
                                        //         $('#pd_province_id').empty();
                                        //         $.each(response, function(index, itemData) {
                                        //             let newOption = new Option(itemData, index, false, false);
                                        //             $('#pd_province_id').append(newOption).trigger('change');
                                        //         });
                                        //         for (let componentsLoop2 = 0; componentsLoop2 < results[0].address_components.length; componentsLoop2++) {
                                        //             if (results[0].address_components[componentsLoop2].types[0] == 'administrative_area_level_1') {
                                        //                 $('#pd_province_id > option').each(function() {
                                        //                     if ($(this).text().toUpperCase() == results[0].address_components[componentsLoop2].long_name.toUpperCase()) {
                                        //                         $(this).parent().select2('val', [$(this).val()]);
                                        //                     }
                                        //                 });
                                        //             }
                                        //         }
                                        //     },
                                        //     error: function(xhr, status, error) {
                                        //         console.log(error);
                                        //     }
                                        // });
                                    }
                                });
                            }
                        }
                    }
                });
            });
        }
    }
}